import axios from 'axios';

let host = process.env.NODE_ENV == 'development' ? 'https://api.un-db.com' : 'https://api.un-db.com';

export default function({ method = 'get', url = '', data = {} }) {
  return new Promise((resolve, reject) => {
    axios[method](`${host}${url}`, method == 'get' ? { params: data } : data) //http://api.un-db.com
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
